// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1k4UO","imageUploader":"EGiftCard_imageUploader__164h2"};